module.exports = __webpack_public_path__ + "img/bar-chart.e9b0c8be.svg";